<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, inject, watch } from "vue";
import { Primitive } from "@maas/vue-primitive";
import { useMenuView } from "../composables/private/useMenuView";
import { useMenuChannel } from "../composables/private/useMenuChannel";
import { MagicMenuInstanceId, MagicMenuViewId } from "../symbols";
import { useMenuRemote } from "../composables/private/useMenuRemote";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicMenuRemote",
  props: {
    channelId: { type: String, required: true },
    viewId: { type: String, required: false },
    instanceId: { type: String, required: false },
    disabled: { type: Boolean, required: false },
    trigger: { type: Array, required: false },
    asChild: { type: Boolean, required: false }
  },
  setup(__props) {
    const injectedInstanceId = inject(MagicMenuInstanceId, __props.instanceId);
    const injectedViewId = inject(MagicMenuViewId, __props.viewId);
    const mappedInstanceId = computed(() => __props.instanceId ?? injectedInstanceId);
    const mappedViewId = computed(() => __props.viewId ?? injectedViewId);
    if (!mappedInstanceId.value) {
      throw new Error(
        "MagicMenuRemote must be nested inside MagicMenuProvider or an instanceId must be provided"
      );
    }
    if (!mappedViewId.value) {
      throw new Error(
        "MagicMenuTrigger must be nested inside MagicMenuView or a viewId must be provided"
      );
    }
    if (!__props.channelId) {
      throw new Error("MagicMenuRemote requires a channelId");
    }
    const mappedChannelId = computed(() => `magic-menu-channel-${__props.channelId}`);
    const mappedTrigger = computed(() => __props.trigger ?? ["mouseenter"]);
    const { getView } = useMenuView(mappedInstanceId.value);
    const view = getView(mappedViewId.value);
    const { initializeChannel, deleteChannel } = useMenuChannel({
      instanceId: mappedInstanceId.value,
      viewId: mappedViewId.value
    });
    const { onClick, onMouseenter } = useMenuRemote({
      instanceId: mappedInstanceId.value,
      viewId: mappedViewId.value,
      mappedChannelId,
      mappedTrigger
    });
    let channel = initializeChannel({ id: mappedChannelId.value });
    watch(
      () => view?.active,
      (value) => {
        if (!value) {
          deleteChannel(mappedChannelId.value);
          channel = initializeChannel({ id: mappedChannelId.value });
        }
      }
    );
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Primitive), {
        class: "magic-menu-remote",
        "data-id": `${_ctx.channelId}-remote`,
        "data-disabled": _ctx.disabled,
        "data-active": _unref(channel)?.active,
        "as-child": _ctx.asChild,
        onClick: _unref(onClick),
        onMouseenter: _unref(onMouseenter)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {
            channelActive: _unref(channel)?.active,
            remoteDisabled: _ctx.disabled
          })
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["data-id", "data-disabled", "data-active", "as-child", "onClick", "onMouseenter"]);
    };
  }
});
</script>

<style>
.magic-menu-remote {
  cursor: var(--magic-menu-remote-cursor, pointer);
}

.magic-menu-remote[data-disabled='true'] {
  pointer-events: none;
}
</style>
